import { createContext, useContext } from 'react'

import { ThemeContextValue } from './theme-context-types'

const ThemeContext = createContext<ThemeContextValue | null>(null)

/**
 * Reads the theme context. Throws if used outside the matching provider.
 *
 * @returns {ThemeContextValue}
 */
const useTheme = (): ThemeContextValue => {
  const context = useContext(ThemeContext)

  if (context === null) {
    throw new Error('useTheme must be used within a ThemeProvider')
  }

  return context
}

export { ThemeContext, useTheme }
